// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QpWG","controls":"styles_controls__2Jfj9","charLimit":"styles_charLimit__r9GKI","input":"styles_input__G7QZQ","send":"styles_send__up9sm"};